import { EMIMETypes } from 'constants/MIMETypes';

export const MAX_FILE_SIZE_IN_MB = 3;
export const ATTACHMENT_NAME_REGEX = /^[\p{L}\p{N}_\-.() ]+$/u;

export const ALLOWED_FILE_TYPES = [
  EMIMETypes.JPG,
  EMIMETypes.JPEG,
  EMIMETypes.PNG,
  EMIMETypes.PDF,
  EMIMETypes.XLSX,
];

export interface IAttachmentValidationError {
  hasError: boolean;
  errorType?: 'emptyFile' | 'fileSize' | 'fileType' | 'fileName';
  errorMessage?: string;
}

export const validateAttachment = (
  file: File | null,
  customFileName: string | null = null,
  maxSizeInMB: number = MAX_FILE_SIZE_IN_MB,
  allowedTypes: string[] = ALLOWED_FILE_TYPES,
): IAttachmentValidationError => {
  const fileName = customFileName || file?.name;

  if (!file) {
    return {
      hasError: true,
      errorType: 'emptyFile',
      errorMessage: 'addAttachment.emptyFile.text',
    };
  }

  const fileSizeInMB = file.size / 1024 / 1024;
  if (fileSizeInMB > maxSizeInMB) {
    return {
      hasError: true,
      errorType: 'fileSize',
      errorMessage: 'addAttachment.fileSizeValidation.text',
    };
  }

  if (!fileName?.match(ATTACHMENT_NAME_REGEX)) {
    return {
      hasError: true,
      errorType: 'fileName',
      errorMessage: 'addAttachment.fileNameValidation.text',
    };
  }

  if (!allowedTypes.includes(file.type)) {
    return {
      hasError: true,
      errorType: 'fileType',
      errorMessage: 'addAttachment.fileTypeValidation.text',
    };
  }

  return {
    hasError: false,
  };
};
